import styled from 'styled-components/macro'

export const Input = styled.input`
  display: block;
  width: 100%;
  font-family: 'Roboto', Arial, Helvetica, sans-serif;
  color: #452562;
  font-size: 16px;
  line-height: 28px;
  background-color: #fff;
  padding: 8px 16px;
  border: 1px solid #b4b4b4;
  border-radius: 4px;
  outline: none;

  ::placeholder {
    color: #c2c2c2;
    opacity: 1;
  }

  &:active,
  &:focus,
  &[value]:not([value='']) {
    border-color: #452562;
  }
`
